module.exports = __webpack_public_path__ + "img/文字组件.763e91cc.png";